import { BackIcon, EqualIcon, GreaterThanOrEqualIcon, LessThanOrEqualIcon } from '@assets/icons';
import { Button, IconButton } from '@components/button';
import { RadioIcon, TextInput } from '@components/form';
import { Group } from '@components/layout';
import { Typography } from '@components/typography';
import { IntComparator } from '@generated/graphql';
import { Divider, RadioGroup, Stack } from '@mui/material';
import { useState } from 'react';
import { FilterComponent } from './types';

export const NumberFilter: FilterComponent<IntComparator[]> = ({
  title,
  filter,
  onApply,
  onBack,
}) => {
  if (filter.type !== 'number') {
    throw new Error('NumberFilter does not support this filter type');
  }
  const value = filter.value?.[0];
  const [dirtyValue, setDirtyValue] = useState(() => (value ? Object.values(value)?.[0] : ''));
  const [dirtyOption, setDirtyOption] = useState(() => (value ? Object.keys(value)?.[0] : 'eq'));
  return (
    <Stack maxHeight="500px">
      <Group alignItems="center" gap={1} sx={{ px: 2 }}>
        <IconButton size={16} onClick={onBack} Icon={BackIcon} />
        <Typography variant="body2">{title}</Typography>
      </Group>
      <Divider sx={{ m: 2 }} flexItem />
      <Stack sx={{ overflowY: 'auto', px: 6, gap: 2 }}>
        <RadioGroup
          row
          sx={{
            flex: 1,
            gap: 1,
            justifyContent: 'center',
            '& .MuiFormControlLabel-label': { height: '24px', lineHeight: '24px' },
          }}
          value={dirtyOption}
          onChange={(e) => setDirtyOption(e.target.value)}
        >
          <RadioIcon value="lte" icon={LessThanOrEqualIcon} />
          <RadioIcon value="eq" icon={EqualIcon} />
          <RadioIcon value="gte" icon={GreaterThanOrEqualIcon} />
        </RadioGroup>
        <TextInput
          value={dirtyValue}
          onChange={(e) => setDirtyValue(Number(e.target.value))}
          type="number"
          sx={{ minWidth: '50px' }}
        />
      </Stack>
      <Divider sx={{ m: 2 }} flexItem />
      <Group justifyContent="flex-end" sx={{ px: 2, gap: 2 }}>
        <Button
          size="small"
          variant="secondary"
          onClick={() => {
            setDirtyValue('');
          }}
        >
          Clear
        </Button>
        <Button
          size="small"
          variant="primary"
          onClick={() => {
            onApply({
              value: [{ [dirtyOption]: dirtyValue }],
            });
          }}
        >
          Apply
        </Button>
      </Group>
    </Stack>
  );
};
